export default [
    {
        path: "/cru-data",
        name: "cru-data",
        component: () => import("@/pages/cru/UnderDevelopment.vue"),
        meta: {
            pageTitle: "CRU - Data",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
    {
        path: "/cru-riset",
        name: "cru-riset",
        component: () => import("@/pages/cru/UnderDevelopment.vue"),
        meta: {
            pageTitle: "CRU - Riset",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
];
